import React from 'react';
import { Container, Navbar } from 'react-bootstrap';
import { CustomNavBrand } from '@ui/components/atoms';
import { CustomNavbarCollapse } from '@ui/components/molecules/CustomNavbarCollapse';
import NavbarStyles from './CustomNavbar.module.scss';

type Props = {
  links: { title: string; titleAr: string; link: string; linkAr: string }[];
};

export const CustomNavbar: React.FC<Props> = ({ links }) => {
  return (
    <Navbar collapseOnSelect expand="lg" className={NavbarStyles.navbar}>
      <Container className={NavbarStyles.navbar__container}>
        <CustomNavBrand />
        <CustomNavbarCollapse links={links} />
      </Container>
    </Navbar>
  );
};
